import React from 'react';
import BestTimeToPostTab from '../shared/BestTimeToPostTab';
import { FACEBOOK } from '../../../config/constants';

const FacebookBestTimeToPostTab: React.FC = () => {
  return (
    <BestTimeToPostTab platforms={[FACEBOOK]} />
  );
};

export default FacebookBestTimeToPostTab;